import moment from 'moment'
import hideOnScroll from "../components/hideonscroll";
import AppBar from "@material-ui/core/AppBar";
export { NotificationManager} from 'react-notifications';
export { translate,Trans} from 'react-i18next';
const TR_ARRAY = [];
for (let i = 0; i < 24; i++) {
    TR_ARRAY.push(i + 1);
}
export function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
export function validatePhone (phone){
  var re = /^(0)+([1-9])+([0-9]{8,9})$/;
    return re.test(phone);
};
export function getBusinessDays(endDate, startDate) {
    var lastDay = moment(endDate);
    var firstDay = moment(startDate);
    let calcBusinessDays = 0 + (lastDay.diff(firstDay, 'days') * 6 -
      (firstDay.day() - lastDay.day()) * 1) / 7;

    //if (lastDay.day() == 6) calcBusinessDays--;//SAT
    if (firstDay.day() == 0) calcBusinessDays--;//SUN

    return calcBusinessDays;
  }
export function pad2(number){
  return (number<10?'0':'')+number;
}
export function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}


export const HOURS = [{ value: "08", name: "8 AM" }, { value: "09", name: "9 AM" }, { value: "10", name: "10 AM" }, { value: "11", name: "11 AM" }, { value: "12", name: "12 PM" }, { value: "13", name: "1 PM" }, { value: "14", name: "2 PM" }, { value: "15", name: "3 PM" }, { value: "16", name: "4 PM" }, { value: "17", name: "5 PM" }, { value: "18", name: "6 PM" }, { value: "19", name: "7 PM" }, { value: "20", name: "8 PM" }, { value: "21", name: "9 PM" }, { value: "22", name: "10 PM" }, { value: "23", name: "11 PM" }, { value: "00", name: "12 AM" }, { value: "01", name: "1 AM" }, { value: "02", name: "2 AM" }, { value: "03", name: "3 AM" }, { value: "04", name: "4 AM" }, { value: "05", name: "5 AM" }, { value: "06", name: "6 AM" }, { value: "07", name: "7 AM" }];
export const MINUTES = ["00", "15", "20", "30", "40", "45"];
export var phone = new Audio('/phone.mp3');
export var callWait = new Audio('/wait.mp3');
export const TIMESREPEAT = TR_ARRAY;
export const REPEATS = [{ "value": "none", "name": "Does not repeat" }, { "value": "day", "name": "Daily" }, { "value": "week", "name": "Weekly" }, { "value": "month", "name": "Monthly" }];
export const TIMEZONES = { "index": ["Africa", "America", "Antarctica", "Atlantic", "Australia", "Europe", "Indian", "Pacific"], "names": { "Africa": ["Abidjan", "Asmera", "Blantyre", "Ceuta", "Douala", "Johannesburg", "Kinshasa", "Lubumbashi", "Mbabane", "Niamey", "Timbuktu", "Accra", "Bamako", "Brazzaville", "Conakry", "El_Aaiun", "Juba", "Lagos", "Lusaka", "Mogadishu", "Nouakchott", "Tripoli", "Addis_Ababa", "Bangui", "Bujumbura", "Dakar", "Freetown", "Kampala", "Libreville", "Malabo", "Monrovia", "Ouagadougou", "Tunis", "Algiers", "Banjul", "Cairo", "Dar_es_Salaam", "Gaborone", "Khartoum", "Lome", "Maputo", "Nairobi", "Porto-Novo", "Windhoek", "Asmara", "Bissau", "Casablanca", "Djibouti", "Harare", "Kigali", "Luanda", "Maseru", "Ndjamena", "Sao_Tome"], "America": ["Adak", "Antigua", "Argentina/Catamarca", "Argentina/Jujuy", "Argentina/Rio_Gallegos", "Argentina/San_Luis", "Aruba", "Atka", "Barbados", "Blanc-Sablon", "Boise", "Campo_Grande", "Catamarca", "Chicago", "Cordoba", "Cuiaba", "Dawson", "Detroit", "Eirunepe", "Fort_Wayne", "Godthab", "Grenada", "Guayaquil", "Havana", "Indiana/Knox", "Indiana/Tell_City", "Indiana/Winamac", "Iqaluit", "Juneau", "Knox_IN", "Lima", "Lower_Princes", "Manaus", "Matamoros", "Menominee", "Mexico_City", "Monterrey", "Montserrat", "Nipigon", "North_Dakota/Beulah", "Ojinaga", "Paramaribo", "Port_of_Spain", "Puerto_Rico", "Recife", "Rio_Branco", "Santarem", "Sao_Paulo", "Sitka", "St_Kitts", "St_Vincent", "Thule", "Toronto", "Virgin", "Yakutat", "Anchorage", "Araguaina", "Argentina/ComodRivadavia", "Argentina/La_Rioja", "Argentina/Salta", "Argentina/Tucuman", "Asuncion", "Bahia", "Belem", "Boa_Vista", "Buenos_Aires", "Cancun", "Cayenne", "Chihuahua", "Costa_Rica", "Curacao", "Dawson_Creek", "Dominica", "El_Salvador", "Fortaleza", "Goose_Bay", "Guadeloupe", "Guyana", "Hermosillo", "Indiana/Marengo", "Indiana/Vevay", "Indianapolis", "Jamaica", "Kentucky/Louisville", "Kralendijk", "Los_Angeles", "Maceio", "Marigot", "Mazatlan", "Merida", "Miquelon", "Montevideo", "Nassau", "Nome", "North_Dakota/Center", "Panama", "Phoenix", "Porto_Acre", "Rainy_River", "Regina", "Rosario", "Santiago", "Scoresbysund", "St_Barthelemy", "St_Lucia", "Swift_Current", "Thunder_Bay", "Tortola", "Whitehorse", "Yellowknife", "Anguilla", "Argentina/Buenos_Aires", "Argentina/Cordoba", "Argentina/Mendoza", "Argentina/San_Juan", "Argentina/Ushuaia", "Atikokan", "Bahia_Banderas", "Belize", "Bogota", "Cambridge_Bay", "Caracas", "Cayman", "Coral_Harbour", "Creston", "Danmarkshavn", "Denver", "Edmonton", "Ensenada", "Glace_Bay", "Grand_Turk", "Guatemala", "Halifax", "Indiana/Indianapolis", "Indiana/Petersburg", "Indiana/Vincennes", "Inuvik", "Jujuy", "Kentucky/Monticello", "La_Paz", "Louisville", "Managua", "Martinique", "Mendoza", "Metlakatla", "Moncton", "Montreal", "New_York", "Noronha", "North_Dakota/New_Salem", "Pangnirtung", "Port-au-Prince", "Porto_Velho", "Rankin_Inlet", "Resolute", "Santa_Isabel", "Santo_Domingo", "Shiprock", "St_Johns", "St_Thomas", "Tegucigalpa", "Tijuana", "Vancouver", "Winnipeg"], "Antarctica": ["Casey", "McMurdo", "Vostok", "Davis", "Palmer", "DumontDUrville", "Rothera", "Macquarie", "South_Pole", "Mawson", "Syowa"], "Asia": ["Aden", "Aqtobe", "Baku", "Calcutta", "Dacca", "Dushanbe", "Hong_Kong", "Jayapura", "Kashgar", "Krasnoyarsk", "Macau", "Nicosia", "Phnom_Penh", "Rangoon", "Seoul", "Tbilisi", "Tokyo", "Ust-Nera", "Yerevan", "Almaty", "Ashgabat", "Bangkok", "Choibalsan", "Damascus", "Gaza", "Hovd", "Jerusalem", "Kathmandu", "Kuala_Lumpur", "Magadan", "Novokuznetsk", "Pontianak", "Riyadh", "Shanghai", "Tehran", "Ujung_Pandang", "Vientiane", "Amman", "Ashkhabad", "Beirut", "Chongqing", "Dhaka", "Harbin", "Irkutsk", "Kabul", "Katmandu", "Kuching", "Makassar", "Novosibirsk", "Pyongyang", "Saigon", "Singapore", "Tel_Aviv", "Ulaanbaatar", "Vladivostok", "Anadyr", "Baghdad", "Bishkek", "Chungking", "Dili", "Hebron", "Istanbul", "Kamchatka", "Khandyga", "Kuwait", "Manila", "Omsk", "Qatar", "Sakhalin", "Taipei", "Thimbu", "Ulan_Bator", "Yakutsk", "Aqtau", "Bahrain", "Brunei", "Colombo", "Dubai", "Ho_Chi_Minh", "Jakarta", "Karachi", "Kolkata", "Macao", "Muscat", "Oral", "Qyzylorda", "Samarkand", "Tashkent", "Thimphu", "Urumqi", "Yekaterinburg"], "Atlantic": ["Azores", "Faroe", "St_Helena", "Bermuda", "Jan_Mayen", "Stanley", "Canary", "Madeira", "Cape_Verde", "Reykjavik", "Faeroe", "South_Georgia"], "Australia": ["ACT", "Currie", "Lindeman", "Perth", "Victoria", "Adelaide", "Darwin", "Lord_Howe", "Queensland", "West", "Brisbane", "Eucla", "Melbourne", "South", "Yancowinna", "Broken_Hill", "Hobart", "North", "Sydney", "Canberra", "LHI", "NSW", "Tasmania"], "Europe": ["Amsterdam", "Berlin", "Busingen", "Guernsey", "Kaliningrad", "Luxembourg", "Monaco", "Podgorica", "San_Marino", "Stockholm", "Vaduz", "Warsaw", "Andorra", "Bratislava", "Chisinau", "Helsinki", "Kiev", "Madrid", "Moscow", "Prague", "Sarajevo", "Tallinn", "Vatican", "Zagreb", "Athens", "Brussels", "Copenhagen", "Isle_of_Man", "Lisbon", "Malta", "Nicosia", "Riga", "Simferopol", "Tirane", "Vienna", "Zaporozhye", "Belfast", "Bucharest", "Dublin", "Istanbul", "Ljubljana", "Mariehamn", "Oslo", "Rome", "Skopje", "Tiraspol", "Vilnius", "Zurich", "Belgrade", "Budapest", "Gibraltar", "Jersey", "London", "Minsk", "Paris", "Samara", "Sofia", "Uzhgorod", "Volgograd"], "Indian": ["Antananarivo", "Kerguelen", "Reunion", "Chagos", "Mahe", "Christmas", "Maldives", "Cocos", "Mauritius", "Comoro", "Mayotte"], "Pacific": ["Apia", "Efate", "Galapagos", "Johnston", "Marquesas", "Noumea", "Ponape", "Tahiti", "Wallis", "Auckland", "Enderbury", "Gambier", "Kiritimati", "Midway", "Port_Moresby", "Tarawa", "Yap", "Chatham", "Fakaofo", "Guadalcanal", "Kosrae", "Nauru", "Palau", "Rarotonga", "Tongatapu", "Chuuk", "Fiji", "Guam", "Kwajalein", "Niue", "Pitcairn", "Saipan", "Truk", "Easter", "Funafuti", "Honolulu", "Majuro", "Norfolk", "Pohnpei", "Samoa", "Wake"] } };
export const COLORS = [{ color: "#F44336", name: "Red" }, { color: "#E91E63", name: "Pink" }, { color: "#9C27B0", name: "Purple" }, { color: "#673AB7", name: "Deep Purple" }, { color: "#3F51B5", name: "Indigo" }, { color: "#2196F3", name: "Blue" }, { color: "#03A9F4", name: "Light Blue" }, { color: "#00BCD4", name: "Cyan" }, { color: "#009688", name: "Teal" }, { color: "#4CAF50", name: "Green" }, { color: "#8BC34A", name: "Light Green" }, { color: "#CDDC39", name: "Lime" }, { color: "#FFC107", name: "Amber" }, { color: "#FF9800", name: "Orange" }, { color: "#FF5722", name: "Deep Orange" }, { color: "#795548", name: "Brown" }];
export const DURATION = [{ value: 15, name: "15 mins" }, { value: 20, name: "20 mins" }, { value: 30, name: "30 mins" }, { value: 40, name: "40 mins" }, { value: 45, name: "45 mins" }, { value: 60, name: "1 hour" }, { value: 90, name: "1.5 hours" }, { value: 120, name: "2 hours" }];
export const RESET_APPOINTMENT = { item: { timestamp_start: 0, timestamp_end: 0, client_id: '', provider_id: '', practice_id: '', notes_general: '', notes_client: '', notes_provider: '', time: '08:00', date: '', repeat: 'none', times: '', duration: 30, color: '', type: '', minutes: '00', hours: '08' } };
export const FILE_IMAGES = "https://firebasestorage.googleapis.com/v0/b/jennifer-anne-cafe.appspot.com/o/"

export const RAPID_HOST = 'skyscanner-skyscanner-flight-search-v1.p.rapidapi.com';
export const RAPID_KEY = '288088b965msh6426d2dbb17423cp11e18ajsn9aed5620d534';
export const SKY_API_PRICE = 'https://skyscanner-skyscanner-flight-search-v1.p.rapidapi.com/apiservices/pricing/v1.0';
export const DWIDTH = 980;
export const styles = theme => ({
  root: {
      flexGrow: 1,
      zIndex: 1,
      backgroundColor:'#32395d',
      overflow: 'hidden',
      position: 'absolute',
      display: 'table',
      height: '100%',
      width: '100%',

  },
  middle: {
      display: 'table-cell',
      verticalAlign: 'top'
  },
  square: {
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: DWIDTH,

      background:'none'
  },
  textField: {
      minWidth: 200,

  },container: {
    maxWidth: "1170px",
    marginLeft: "auto",
    marginRight: "auto",
    padding: "10px"
  },
  tellInput: {
    width: "100%",
    height: "56px",
    borderRadius: "4px"
  },
  centerFlex:{
    display:'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});
export const MyStyle = {
  BG_COLOR:'#0e1227',
  TEXT_COLOR:'white',
  BG_TRANS_FULL:'rgba(0,0,0,0.4)',
  BG_TRANS:'rgba(0,0,0,0.7)'


}

export const AutoHideAppBar = hideOnScroll(AppBar);

export function calSize(x,width)
{
  return (width)*(x/DWIDTH);
}

export const SERVER = "https://us-central1-ve-gia-re.cloudfunctions.net/";
export const API_USER_CHECKANDCREATEUSER = SERVER+'User_CheckAndCreateAccount';

export const API_RAPID_SESSION = 'https://skyscanner-skyscanner-flight-search-v1.p.rapidapi.com/apiservices/pricing/v1.0';
export const API_RAPID_SEARCH = 'https://skyscanner-skyscanner-flight-search-v1.p.rapidapi.com/apiservices/pricing/uk2/v1.0/';
export const API_RAPID_PLACE = 'https://skyscanner-skyscanner-flight-search-v1.p.rapidapi.com/apiservices/autosuggest/v1.0/VN/VND/vi-VN/';
export async function loadJSONData(url) {
  try {
         const response = await  fetch(url);
         const responseJson = await response.json();
         return responseJson;
     } catch(error){
          console.error(error);
          return null;
     }
}
export async function postJSONData(url,data) {

var formBody = JSON.stringify(data);


try {
const response = await fetch(url, {

  method: 'POST',
  body: formBody
});
const responseJson = await response.json();
return responseJson;
} catch(error){
     console.error(error);
     return null;
}
}
export async function getSessionRapid(data)
{
  var formBody = [];
for (var property in data) {
  var encodedKey = encodeURIComponent(property);
  var encodedValue = encodeURIComponent(data[property]);
  formBody.push(encodedKey + "=" + encodedValue);
}
formBody = formBody.join("&");
try {
const response = await fetch(API_RAPID_SESSION, {
"method": "POST",
"headers": {
"x-rapidapi-host": RAPID_HOST,
"x-rapidapi-key": RAPID_KEY,
"content-type": "application/x-www-form-urlencoded"
},
"body": formBody
});

const responseJson = await response.headers.get('location');
return {status:1,location:responseJson};;
} catch(error){
     console.error(error);
     return null;
}
}

export async function getDataRapid(url,data)
{
  var formBody = [];
for (var property in data) {
  var encodedKey = encodeURIComponent(property);
  var encodedValue = encodeURIComponent(data[property]);
  formBody.push(encodedKey + "=" + encodedValue);
}
formBody = formBody.join("&");
try {
const response = await fetch(url+'?'+formBody, {

  method: 'GET',

  headers: {
    "x-rapidapi-host": RAPID_HOST,
  		"x-rapidapi-key": RAPID_KEY,
  },

});

const responseJson = await response.json();
return responseJson;
} catch(error){
     console.error(error);
     return null;
}
}
export async function postFormData(url,data) {


var formBody = [];
for (var property in data) {
  var encodedKey = encodeURIComponent(property);
  var encodedValue = encodeURIComponent(data[property]);
  formBody.push(encodedKey + "=" + encodedValue);
}
formBody = formBody.join("&");
try {
const response = await fetch(url, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  },
  body: formBody
});
const responseJson = await response.json();
return responseJson;
} catch(error){
     console.error(error);
     return null;
}
}
export async function postFormData2(url,data) {


  let formData = new FormData();
  // Assume "photo" is the name of the form field the server expects

for (var property in data) {

  formData.append(property, data[property]);
}

try {
const response = await fetch(url, {
  method: 'POST',
  body: formData,
  header: {
    'content-type': 'multipart/form-data',
  }
});
const responseJson = await response.json();
return responseJson;
} catch(error){
     console.error(error);
     return null;
}
}
